/**
 * Sistema unificado de permissoes.
 * Todas as permissoes vem do array user.permissoes (tabela user_permissoes).
 * Paginas comecam com "/" (ex: "/vendas"), acoes nao (ex: "produtos_acoes").
 */

const getUser = () => {
    try {
        const userString = window.localStorage.getItem("user");
        return userString ? JSON.parse(userString) : null;
    } catch (_) {
        return null;
    }
};

const getPermissoes = () => getUser()?.permissoes || [];

/**
 * checkPermission — substitui o antigo check por tipo (1 ou 4).
 * Agora checa se o usuario tem a permissao "acoes_gerenciais".
 */
export const checkPermission = () => {
    return getPermissoes().includes("acoes_gerenciais");
};

/**
 * checkPermissionUser — checa se o usuario tem uma permissao especifica.
 * @param {string} recurso - nome da permissao (ex: "vendas_acoes_massa", "produtos_acao_editar")
 */
export const checkPermissionUser = (recurso) => {
    return getPermissoes().includes(recurso);
};

/**
 * hasPagePermission — checa se o usuario tem acesso a uma pagina.
 * @param {string} pagina - rota da pagina (ex: "/vendas", "/dashboard")
 */
export const hasPagePermission = (pagina) => {
    const user = getUser();
    // Admin (tipo 1) passa sempre — e lista VAZIA NEGA, igual ao backend
    // (middleware PermissaoPagina). Liberar tudo para quem nao tem nenhuma
    // permissao e uma escotilha: usuario recem-criado nasce sem linha.
    if (Number(user?.tipo) === 1) return true;

    const alvo = String(pagina || "").trim();
    if (!alvo) return false;

    return (user?.permissoes || []).some(p => {
        const rota = String(p || "").trim();
        // Linha em branco liberaria qualquer rota que comece com "/".
        if (!rota) return false;
        return alvo === rota || alvo.startsWith(rota + "/");
    });
};

/**
 * Blocos da Dashboard V3 visiveis por tipo de usuario
 * (1 Administrador, 2 Vendedor, 3 Operacoes, 4 Suporte).
 * Tipo sem blocos nao acessa a dashboard.
 */
const DASHBOARD_BLOCOS_POR_TIPO = {
    1: ["radar", "vendas", "vendedores", "compras", "logistica", "produtos", "posVenda", "tickets", "reputacao"],
    3: ["logistica"],
    4: ["posVenda", "tickets", "reputacao"],
};

export const dashboardBlocos = (user) => DASHBOARD_BLOCOS_POR_TIPO[Number(user?.tipo)] || [];

/**
 * podeVerDashboard — acessa a dashboard quem tem algum bloco liberado
 * (independe da lista de permissoes de pagina).
 */
export const podeVerDashboard = (user) => dashboardBlocos(user).length > 0;
